import * as Module from '../scrub'

Object.assign(window, Module);
